import { makeAutoObservable, runInAction, reaction } from "mobx";
import { getBidStatusHistory, NormalizedError } from "services";
import { RequestProcessingHistoryType, StatusHistoryType } from "../interfaces/statuses";
import { statusFetching } from "constants/types";
import { BidCardStore } from "./BidInfoStore";
import { getFeatureStatuses } from "pages/BidInfoPage/BidSteps/utils";

export class BidHistory {
  statusHistory: StatusHistoryType[] = [];
  processingHistory: RequestProcessingHistoryType[] = [];
  loading = false;
  fetchStatus: statusFetching = "init";
  fetchError?: NormalizedError;
  store: BidCardStore | null = null;

  constructor(store: BidCardStore) {
    makeAutoObservable(this);
    this.store = store;
    reaction(
      () => [this.store?.bid?.status, this.store?.bid?.id],
      () => {
        if (this.store?.bid.id) {
          this.fetchStatusHistory(this.store.bid.id);
        }
      }
    );
  }

  /**
   * Геттер для компонента BidSteps
   */
  get stepStatuses() {
    const currentStatus = this.statusHistory.at(-1)?.status ?? this.store?.bid.status;

    if (!currentStatus || !this.store?.bid) return [];

    const featureStatuses = getFeatureStatuses(currentStatus, this.store.bid);

    return this.statusHistory.concat(featureStatuses.map((str) => ({ status: str, statusDate: "" })));
  }

  /**
   * Геттер processingHistory для sub steps в BidSteps в виде [key]: [values]
   * */
  get processingHistoryTooltip() {
    return this.processingHistory.reduce(
      (acc: Record<string, RequestProcessingHistoryType[]>, item) => {
        const actionType = item.actionType;

        if (!acc[actionType]) {
          acc[actionType] = [];
        }

        acc[actionType].push(item);
        return acc;
      },
      {} as Record<string, RequestProcessingHistoryType[]>
    );
  }

  async fetchStatusHistory(id: string) {
    this.loading = true;
    this.fetchStatus = "fetching";
    this.fetchError = undefined;

    try {
      const history = await getBidStatusHistory({ id });
      runInAction(() => {
        this.statusHistory = history.requestHistory;
        this.processingHistory = history.requestProcessingHistory;
        this.fetchStatus = "success";
      });
    } catch (error: any) {
      runInAction(() => {
        this.fetchStatus = "error";
        this.fetchError = error;
      });
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }
}
